export const permissionDenied = 'SnackBars.PermissionDenied';
